var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view parent-wrapper" },
    [
      _c("tab-query-page", {
        ref: "queryPage",
        attrs: {
          properties: _vm.properties,
          "account-set": _vm.accountSet,
          "has-voucher": 1,
          "show-batch": false,
          "voucher-page": 1,
          "pre-bank-slip-states": _vm.preBankSlipStates
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }